import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'
import { constants } from 'helpers'
import { useFt } from 'hooks'

import { Image, Text } from 'components/dataDisplay'
import { AspectContainer, WidthContainer } from 'components/layout'

import messages from './messages'

import bgImageDesktopOld from './images/bg-0-desktop.jpg?src-loader&size'
import bgImageMobileOld from './images/bg-0-mobile.jpg?src-loader&size'
import bgImageDesktopRebrand from './images/bg-desktop-rebrand.jpg?src-loader&size'
import bgImageMobileRebrand from './images/bg-mobile-rebrand.jpg?src-loader&size'
import brandsImageDesktop from './images/brands-desktop.png?src-loader&size'
import brandsImageMobile from './images/brands-mobile.png?src-loader&size'


type BrandsQualityBlockProps = {
  className?: string
  button?: React.ReactNode
}

const BrandsQualityBlock: React.FunctionComponent<BrandsQualityBlockProps> = ({ className, button = null }) => {
  const { isMobile } = useDevice()
  const isPhysicalRebrandCaseEnabled = useFt(constants.features.physicalRebrandCase)

  if (isMobile) {
    const bgImageMobile = isPhysicalRebrandCaseEnabled ? bgImageMobileRebrand : bgImageMobileOld

    return (
      <div className={cx(className, 'bg-light-beige')} data-testid="brandsSection">
        <AspectContainer aspect={bgImageMobile.aspect}>
          <Image src={bgImageMobile.src} lazy />
        </AspectContainer>
        <div className="pt-24 px-16 text-center">
          <Text message={messages.title} style="h4" />
          <Text className="mt-24" message={messages.text} style="p3" />
          <Image className="mt-24 w-full" {...brandsImageMobile} lazy alt="Bvlgari, Tocca, Kenneth Cole, Michael Kors, Marc Jacobs, Balenciaga" />
          <Text className="mt-24" message={messages.note} style="p3" html />
          {button}
        </div>
      </div>
    )
  }

  const bgImageDesktop = isPhysicalRebrandCaseEnabled ? bgImageDesktopRebrand : bgImageDesktopOld

  return (
    <WidthContainer className={className} data-testid="brandsSection">
      <div className="flex items-center justify-between bg-light-beige">
        <div className="py-32 pr-32 pl-64 max-w-464">
          <Text message={messages.title} style="h3" />
          <Text className="mt-24" message={messages.text} style="p3" />
          {button}
        </div>
        <AspectContainer className="w-6/12" aspect={bgImageDesktop.aspect}>
          <Image src={bgImageDesktop.src} lazy />
        </AspectContainer>
      </div>
      <Image className="mt-24 px-12 w-full" {...brandsImageDesktop} lazy alt="Bvlgari, Michael Kors, Marc Jacobs, Tocca, Balenciaga" />
      <Text className="mt-24 text-center" message={messages.note} style="p1" html />
    </WidthContainer>
  )
}


export default React.memo(BrandsQualityBlock)
